module.exports = __webpack_public_path__ + "static/media/firstpasslogo-dark.a012521f.svg";